import Base from '../../base'

export default class Default extends Base {
  init() {
    if (this.d.template.indexOf('customers/login') == -1) return
  }
}
